import { Modal, Button, Form, message, Typography } from 'antd';
import { useCreateServicio } from '../api/useServicios';
import { useT } from '../../../locales';
import { ServicioForm } from './ServicioForm';
import type { CreateServicioDto } from '@aid/shared';

const { Text } = Typography;

interface ServicioCreateModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  preselectedClienteId?: number;
}

export function ServicioCreateModal({
  open,
  onClose,
  onSuccess,
  preselectedClienteId,
}: ServicioCreateModalProps) {
  const t = useT();
  const [form] = Form.useForm();
  const createServicio = useCreateServicio();

  const handleSubmit = async (values: CreateServicioDto) => {
    try {
      await createServicio.mutateAsync(values);
      message.success(t('pages.servicios.createSuccess'));
      onClose();
      onSuccess?.();
    } catch {
      message.error(t('pages.servicios.createError'));
    }
  };

  return (
    <Modal
      title={
        <div>
          <div>{t('pages.servicios.create')}</div>
          <Text type="secondary" style={{ fontSize: 13, fontWeight: 400 }}>
            {t('pages.servicios.createSubtitle')}
          </Text>
        </div>
      }
      open={open}
      onCancel={onClose}
      destroyOnHidden
      centered
      width={640}
      styles={{ body: { maxHeight: 'min(75vh, 675px)', overflowY: 'auto' } }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('common.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={createServicio.isPending}
          onClick={() => form.submit()}
        >
          {t('pages.servicios.create')}
        </Button>,
      ]}
    >
      <ServicioForm
        mode="create"
        form={form}
        hideSubmit
        onSubmit={handleSubmit}
        loading={createServicio.isPending}
        preselectedClienteId={preselectedClienteId}
      />
    </Modal>
  );
}
